<template>
  <div style="max-width:100%;">
    <slot>
      <span
          class="ellipsis"
          v-tooltip="cellContent"
          v-if="cellContent && cellContent.length > 20"
          v-html="stripVerticalBar(cellContent)"></span>
      <span v-else class="ellipsis" v-html="stripVerticalBar(cellContent) || '-'"></span>
    </slot>
  </div>
</template>


<script>
  export default {
    name: 'AsCell',
    computed: {
      
      cellContent () {
        let { row, column } = this.props;
        let rowContent = row ? row[column] : null;

        return this.content || rowContent;
      }
    },
    props: {
      
      props: {
        type: [Array, Object],
        required: true
      },
      content: [Number, String, Object, Array, Boolean],
    },
    
    methods: {
      stripVerticalBar (str = '') {
        if (!str || !(typeof str == 'string' )) return;

        return str.replace(/\|/, "")
      },
    },
    
    data () {
      return {};
    }
  };
</script>
